<template>
  <app-card-secador-lote-skeleton v-bind="$attrs" v-on="$listeners" :actions="actions"
  @click="$_emitter" class="my-2">
    <template #contrato >
    <div class="cardsecadorlote">
      <div v-if="value.id" class="idsecadorlote"> {{ value.id }} </div>
      <div v-if="value.inicio">
        {{$_formataData(value.inicio,'DD/MM/YYYY ')}} 
        {{$_formataData(value.inicio,'HH:mm -')}}  
      </div>
      <div v-if="value.nrolote">  - {{   value.nrolote}} </div>
    </div>
      <div class="header__container" v-if="!semBotoes">
        <v-btn icon class="header__btn-editar">
          <v-icon large @click="$emit('onClickEditar', value.id)">
            mdi-pencil-box-outline
          </v-icon>
        </v-btn> 
        <v-btn icon class="header__btn-editar remover">
          <v-icon large @click="$emit('onClickRemover', value.id)">
            mdi-close-box-outline
          </v-icon>
        </v-btn> 
      </div>

     </template>
     <template #detalhe1>
      <!-- <span v-if="value.operacao">Operação: {{value.operacao}}</span>
      <br>
      <span v-if="value.umidade">Umidade: {{value.umidade}}%</span>
      <br>
      <span v-if="value.peso">Peso: {{value.peso}} kg</span>
      <br> -->
      <span v-if="value.status">Status: {{value.status}}</span>
      <br>
      <span v-if="value.termino">Data de Termino:
        {{$_formataData(value.termino,'DD/MM/YYYY ')}} 
        {{$_formataData(value.termino,'HH:mm')}}  
      </span>
      <br>
      <span v-if="value.usuario">
        Último Operador:
        {{value.usuario.id}} - {{value.usuario.nome}}
      </span>
     </template>
  </app-card-secador-lote-skeleton>
</template>

<script>
import moment from 'moment-timezone';
import AppCardSecadorLoteSkeleton from './Skeleton.vue';

export default {
  name: 'AppCardSecadorLote',

  components: {
    AppCardSecadorLoteSkeleton,
  },

  methods: {
    // FormataData(date) {
    //   // return moment(date, 'YYYY-MM-DD').format('DD/MM-HH:MM');
    //   return moment.tz(date, 'America/Sao_Paulo').local().format('DD/MM-HH:mm');
    // },

    $_formataData(date, mascara) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(mascara);
    },

    $_temDescricao(value) {
      // VUE não suporta optional chaining direto no template.
      if (value.produto?.prodescricao) {
        return true;
      }
      return false;
    },

    $_emitter() {
      this.$emit('innerClick', this.value.id);
    },
  },

  props: {
    value: Object,
    actions: Boolean,
    semBotoes: Boolean,
  },

  watch: {
    value: {
      immediate:true,
      deep:true,
      handler() {
        console.log('propv', this.$props.value)
      }
    }
  }
};
</script>
/<style scoped>
#principal{
  display: block;
}

.flex-container {
  display: flex;
}

.flex-container > * {
  margin-right: 3px;
}

.idsecadorlote {
  margin-right: 10px;
}

.cardsecadorlote {
  display: flex;
}
.header__container {
  display: flex;
  flex-direction: column;
  float: right;
}

.header__btn-editar {
  transform: translateY(-100%) translateX(10px);
}

.header__btn-editar:hover {
  color: #4CAF50;
}

.remover:hover {
  color: #a31414;
}
</style>
